"use strict";

var _regeneratorRuntime = require("/Volumes/Workspace/archlog/repos/webapp/deploy/develop/node_modules/@babel/runtime/regenerator/index.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectTagNamespaces = void 0;
require("regenerator-runtime/runtime.js");
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/**
 * Client for Project Tag Namespaces
 */
var ProjectTagNamespaces = /*#__PURE__*/function () {
  /**
   */
  function ProjectTagNamespaces(params) {
    var _this = this;
    _classCallCheck(this, ProjectTagNamespaces);
    _defineProperty(this, "getEntries", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(project) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.validateProject(project);
                return _context.abrupt("return", _this.httpClient.get("/projects/".concat(project, "/namespaces")).then(function (_ref2) {
                  var data = _ref2.data;
                  return data;
                }));
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(this, "setEntries", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(project, namespaces) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.validateProject(project);
                return _context2.abrupt("return", _this.httpClient.post("/projects/".concat(project, "/namespaces"), namespaces).then(function (_ref4) {
                  var data = _ref4.data;
                  return data;
                }));
              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return function (_x2, _x3) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(this, "putEntry", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(project, ns) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this.validateProject(project);
                return _context3.abrupt("return", _this.httpClient.put("/projects/".concat(project, "/namespaces/").concat(encodeURIComponent(ns))).then(function (_ref6) {
                  var data = _ref6.data;
                  return data;
                }));
              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return function (_x4, _x5) {
        return _ref5.apply(this, arguments);
      };
    }());
    _defineProperty(this, "removeEntry", /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(project, ns) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this.validateProject(project);
                return _context4.abrupt("return", _this.httpClient["delete"]("/projects/".concat(project, "/namespaces/").concat(encodeURIComponent(ns))).then(function (_ref8) {
                  var data = _ref8.data;
                  return data;
                }));
              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return function (_x6, _x7) {
        return _ref7.apply(this, arguments);
      };
    }());

    //
    this.httpClient = _axios["default"].create(_objectSpread({
      withCredentials: true
    }, params));
  }
  /**
   */

  _createClass(ProjectTagNamespaces, [{
    key: "validateProject",
    value: function validateProject(project) {
      if (!project) {
        throw new Error('Project is not specified.');
      }
    }
    /**
     * Get tags for project product
     */
  }]);

  return ProjectTagNamespaces;
}();
exports.ProjectTagNamespaces = ProjectTagNamespaces;